import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';
import {Form} from 'components/ui-kit/Form';
import {Hint} from 'components/ui-kit/Hint';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

export const CustomTitle = styled(Title)`
    color: #59606a;
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 40px;
`;

export const CustomForm = styled(Form)`
    display: grid;
    column-gap: 48px;
    row-gap: 30px;
    max-width: 980px;
    margin-top: 40px;
    margin-bottom: 100px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;

    @media (min-width: ${breakpoint.tablet}) {
        grid-template-columns: 1fr 1fr 1fr;
    }
`;

export const Field = styled(Hint)`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: 12px;
        color: ${colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

export const Actions = styled.div`
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    justify-content: flex-end;
`;

export const SubmitButton = styled(Button)`
    max-width: 240px;
`;

export const AddButton = styled(Button)`
    max-width: 240px;
`;

export const BackButton = styled(Button)`
    max-width: 240px;
    color: ${colors.textPrimary};
    text-decoration: none;
`;
